import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { UerExportWorkOrderPricesQuery } from 'gql/graphql';
import { uerExportWorkOrderPricesGql } from 'pages/Project/UerProject/WorkOrder/workOrderQueries';
import { downloadURI } from 'utils/downloadDataURI';
import type { TActionCommonInterface } from 'utils/types';

import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

interface IUseUerExportWorkOrderPrices {
    workOrderId: number;
}

const requestId = 'uerExportWorkOrderPrices';

export const useUerExportWorkOrderPrices = (props: IUseUerExportWorkOrderPrices) => {
    const dispatch = useDispatch();
    const { workOrderId } = props;

    const [uerExportWorkOrderPricesReset] = useResetStoreData({ requestId });

    const successHandler = useCallback(
        (successData: TActionCommonInterface<UerExportWorkOrderPricesQuery>) => {
            const { dataUrl, name } = successData.payload?.uerExportWorkOrderPrices?.data ?? {};

            if (dataUrl && name) {
                downloadURI(dataUrl, name);
            }

            uerExportWorkOrderPricesReset(undefined);
        },
        [uerExportWorkOrderPricesReset],
    );

    const [, uerExportWorkOrderPricesStatus, , uerExportWorkOrderPricesRequest, , uerExportWorkOrderPricesAbort] =
        useRequest({
            requestId,
            query: uerExportWorkOrderPricesGql,
            withEffect: false,
            dependenciesUpdater: successHandler,
        });

    const doUerExportWorkOrderPricesRequest = useCallback(() => {
        uerExportWorkOrderPricesReset(undefined);
        dispatch(uerExportWorkOrderPricesRequest({ workOrderId }));
    }, [dispatch, uerExportWorkOrderPricesRequest, uerExportWorkOrderPricesReset, workOrderId]);

    const doUerExportWorkOrderPricesAbort = useCallback(() => {
        dispatch(uerExportWorkOrderPricesAbort(undefined));
    }, [dispatch, uerExportWorkOrderPricesAbort]);

    return {
        doUerExportWorkOrderPricesRequest,
        doUerExportWorkOrderPricesAbort,
        uerExportWorkOrderPricesStatus,
    };
};
